
  <cx-media [container]="main"></cx-media>

